import { render, staticRenderFns } from "./NetworkPage.vue?vue&type=template&id=4973aa98&scoped=true"
import script from "./NetworkPage.vue?vue&type=script&lang=js"
export * from "./NetworkPage.vue?vue&type=script&lang=js"
import style0 from "./NetworkPage.vue?vue&type=style&index=0&id=4973aa98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973aa98",
  null
  
)

export default component.exports